export default "__VITE_ASSET__De3dcLf8__"